<template>
    <div class="group-animated" :class="mainClass">
        <slot></slot>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'question-selector-enabler',

    computed: {
        mainClass ()
        {
            const out = []
            if (this.exportBuildings === true)
            {
                out.push('disabled-group')
            }
            return out
        },

        ...mapState({
            exportBuildings: state => state.exportBuildings,
        }),
    },
}
</script>

<style scoped>
    .group-animated {
        max-height: 2000px;
        overflow: auto;
        overflow-y: scroll;
        transition: max-height 500ms ease-in-out, opacity 500ms;
    }
    .disabled-group {
        opacity: 0.25;
        pointer-events: none;
        user-select: none;
        user-focus: none;
        user-input: none;
        max-height: 0;
        overflow-y: hidden;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/vue/question-selector-enabler.vue